module.exports = __webpack_public_path__ + "img/logo.ab79f527.png";